
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import getT from 'next-translate/getT';
import { GridLocation } from '@/templates';
import FlexibleContent from '@/templates/flexible-content';
import config from '@/config';
import i18n from '@/i18n';
import { getLayout } from '@/components/Layout';
import { getCities, getCommonData, getProvinces } from '@/graphql/api';
import { getAllRoutes } from '@/graphql/api/getAllRoutes';
import { client } from '@/graphql/client';
import { getLocation } from '@/graphql/queries';
import { houseTransformer } from '@/graphql/transformer/houseTransformer';
import { errorGrahpQL, getWordpressPath } from '@/graphql/utils';
import { sectionTransformer } from '@/lib/graphql/transformer/sections';
import type { TypeFlexibleContent } from '@/lib/graphql/transformer/sections';
import type { TypeHousingCardProps } from '@/organisms/housing-card';
import type { TypeGridLocationProps } from '@/templates/grid-location';
import type { GetStaticProps } from 'next';
import type { AppCommonProps } from 'pages/_app';
type PageProps = {
    flexibleContent: TypeFlexibleContent[];
    gridLocation: TypeGridLocationProps;
};
export const Location = ({ flexibleContent, gridLocation }: PageProps) => (<>
    <GridLocation {...gridLocation}/>
    <FlexibleContent flexibleContent={flexibleContent}/>
  </>);
const getStaticProps: GetStaticProps<PageProps & AppCommonProps> = async ({ locale: onGoingLocale, params }) => {
    const { uri: uriPage } = params || {};
    const locale = onGoingLocale ?? i18n.defaultLocale;
    const location = await client.query({
        query: getLocation,
        variables: {
            slug: getWordpressPath({
                slug: uriPage,
                locale,
                path: '/on-som',
            }),
        },
    });
    const data = location?.data?.location;
    errorGrahpQL(location);
    if (!data ||
        !data.language.locale.includes(locale) ||
        data.edificios.edges.length === 0)
        return { notFound: true };
    const { name, count = 0, edificios, ancestors, parent, uri, slug, databaseId: id, contenidoFlexible: { contenido: flexibleContentData = [] }, seo, contenido, } = data;
    const buildings: Array<TypeHousingCardProps & {
        subtitle: string;
    }> = [];
    edificios?.edges?.forEach(async (building: any) => {
        const buildingsTemp = await houseTransformer(building?.node?.edificio, locale, building.node.databaseId);
        buildings.push({
            ...buildingsTemp,
            subtitle: `${name}${ancestors?.edges ? ', ' : ''}${ancestors?.edges
                ?.map((ancestor: any) => ancestor?.node?.name)
                .join(', ') ?? ''}`,
        });
    });
    const { provinces } = await getProvinces(locale);
    const provinceDefaultValue: {
        id: number;
        label: string;
        href: string;
    } = ancestors
        ? ancestors.edges
            .map((location: any) => ({
            id: location?.node?.databaseId,
            label: location?.node?.name,
            href: location?.node?.uri,
        }))
            .at(-1)
        : provinces.find((location) => location.id === id);
    const cities = await Promise.all(provinces.map(async (province) => [
        province.id,
        await getCities({ id: Number(province.id) }),
    ]));
    const databaseId = data?.contenido?.edificio?.databaseId;
    const flexibleContent = await sectionTransformer({
        flexibleContent: flexibleContentData,
        building: null,
        locale: locale ?? i18n.defaultLocale,
        buildingId: databaseId,
    });
    const { footer, header } = await getCommonData({
        locale: locale ?? i18n.defaultLocale,
        content: contenido,
        translations: data.translations,
    });
    const t = await getT(locale, 'location');
    return {
        props: {
            seo,
            flexibleContent,
            header,
            footer,
            gridLocation: {
                buildings,
                pretitle: t('pretitle'),
                title: t('title', { location: name }),
                description: t('description', { location: name, quantity: count }),
                ancestor: parent
                    ? {
                        label: t('viewAncestralLocation', { location: parent.node.name }),
                        href: parent.node.uri,
                    }
                    : {
                        label: t('viewAncestralLocation', { location: t('country') }),
                        href: uri.replace(new RegExp(`\/?${slug}\/?`), ''),
                    },
                searchBox: {
                    provinces: {
                        values: provinces,
                        defaultValue: provinceDefaultValue,
                    },
                    cities: {
                        citiesList: cities,
                        ...(ancestors
                            ? {
                                defaultValue: {
                                    id,
                                    label: name,
                                    href: uri,
                                },
                            }
                            : {
                                placeholder: t('city'),
                            }),
                    },
                },
            },
        },
        revalidate: config.revalidate,
        notFound: !data,
    };
};
export const getStaticPaths = async () => ({
    paths: await getAllRoutes({ type: 'locations', locale: 'ca' }),
    fallback: 'blocking',
});
Location.getLayout = getLayout;
export default Location;

    async function __Next_Translate__getStaticProps__18e563d8f4b__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/on-som/[...uri]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__18e563d8f4b__ as getStaticProps }
  